<template>
    <el-dialog  title="审核内容" :close-on-press-escape="false" :visible.sync="dialogVisible" width="35%"
        :before-close="handleClose">

        <el-image :preview-src-list="[`${$Api.obs}/${record.hand_image_upload}`,`${$Api.obs}/${record.hand_image}`,`${$Api.obs}/${record.front_image}`,`${$Api.obs}/${record.rear_image}`]" style="width: 50%; height:150px"
            :src="`${$Api.obs}/${record.hand_image_upload}`"></el-image>
        <el-image :preview-src-list="[`${$Api.obs}/${record.hand_image_upload}`,`${$Api.obs}/${record.hand_image}`,`${$Api.obs}/${record.front_image}`,`${$Api.obs}/${record.rear_image}`]" style="width: 50%; height:150px"
            :src="`${$Api.obs}/${record.hand_image}`"></el-image>
        <el-image :preview-src-list="[`${$Api.obs}/${record.hand_image_upload}`,`${$Api.obs}/${record.hand_image}`,`${$Api.obs}/${record.front_image}`,`${$Api.obs}/${record.rear_image}`]" style="width: 50%; height:150px"
            :src="`${$Api.obs}/${record.front_image}`"></el-image>
        <el-image :preview-src-list="[`${$Api.obs}/${record.hand_image_upload}`,`${$Api.obs}/${record.hand_image}`,`${$Api.obs}/${record.front_image}`,`${$Api.obs}/${record.rear_image}`]" style="width: 50%; height:150px"
            :src="`${$Api.obs}/${record.rear_image}`"></el-image>
        <el-row style="margin-top: 12px;">
            <el-col :span="6">
                审核结果:
            </el-col>
            <el-col :span="15">
                <el-radio-group v-model="status">
                    <el-radio :label="1">不通过</el-radio>
                    <el-radio :label="2">通过</el-radio>
                </el-radio-group>
            </el-col>
        </el-row>
        <el-row v-if="status !== 2" style="margin-top: 12px;">
            <el-col :span="6">
                审核意见:
            </el-col>
            <el-col :span="18">
                <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="fail_reason">
                </el-input>
            </el-col>
        </el-row>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClick">取 消</el-button>
            <el-button type="primary" @click="quedingClick">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    props: {	//  在props中接收父组件传过来的值
        dialogVisible: {
            type: Boolean
        },
        record: {
            type: Object
        },
        handleClose: {
            type: Function
        }
    },
    data() {
        return {
            status: 2,
            fail_reason: '',
        };
    },
    methods: {
        handleClick() {
            this.handleClose()
        },
        quedingClick() {
            this.$emit('workerCertification',{worker_id:this.record.worker_id,status:this.status,fail_reason:this.fail_reason})
        }
    }
};
</script>